import React, { useState, useEffect } from 'react';
import {Form, Input, Drawer, Button } from 'antd';
import { AutoCompleteProdutos } from '../../componentes/auto-complete-produto/auto-complete-produtos';
import {useRelacaoProdutoFornecedor} from './useRelacaoProdutoFornecedor';

const FormCadastroProdutoFornecedor = ({
    relacao, onFinish, visible, onClose
}) => {
    const pSelecionadoInicial = (relacao && {
        codigo: relacao.codigoProduto,
        descricao: relacao.descricao
    }) || false;
    
    const [formRef] = Form.useForm();

    const [produtoSelecionado,setProdutoSelecionado] = useState(pSelecionadoInicial);
    const {salvarRelacao} = useRelacaoProdutoFornecedor();

    const [salvando, setSalvando] = useState(false);
    
    useEffect(() => {

        setProdutoSelecionado((relacao && {
            codigo: relacao.codigoProduto,
            descricao: relacao.descricao
        }) || false);

    },[relacao])

    
    const onSelect = (produto) => {
        setProdutoSelecionado(produto);
    }
    const salvarHandle = async function(){
        setSalvando(true)
        const relacao = formRef.getFieldsValue();

        try{

            relacao.codigoProduto = produtoSelecionado.codigo;
            relacao.unMedida = produtoSelecionado.uCom;
            
            await salvarRelacao(relacao);
        } catch(e){
            console.log(e);
        } finally{
            setSalvando(false);
            onClose(true);
        }


    }
    return (<>
        <Drawer visible={visible} onClose={onClose}
            width={400}
            footer={<>
                <Button type="link" onClick={()=> onClose()}>Cancelar</Button>
                <Button type="primary" loading={salvando} onClick={salvarHandle}>Salvar</Button>
            </>}
        >

            <h3>Relacão Produto Fornecedor {relacao.codigoProduto}</h3>
            <Form form={formRef} layout="vertical">
                        <Form.Item
                            hidden={true}
                            name="id"
                            initialValue={relacao.id}
                            
                        >
                            <Input type="hidden" />
                        </Form.Item>

                        <Form.Item
                            name="produto"
                            initialValue={relacao.codigoProduto}
                            label="Produto"
                        >
                            <AutoCompleteProdutos  onSelectProduto={onSelect} ></AutoCompleteProdutos>
                        </Form.Item>

                        

                        {(() => {
                            if(produtoSelecionado){
                                return (<>
                                    <Form.Item
                                        name="codigoProdutoFornecedor"
                                        initialValue={relacao.codigoProdutoFornecedor}
                                        label={`Código Fornecedor` }
                                    
                                    >
                                        <Input  placeholder=""></Input>
                                    </Form.Item>

                                    <Form.Item
                                        name="unMedidaFornecedor"
                                        initialValue={relacao.unMedidaFornecedor}
                                        label={`Unidade Medida Fornecedor` }
                                    
                                    >
                                        <Input  placeholder=""></Input>
                                    </Form.Item>

                                    <Form.Item
                                        name="fatorMultFornecedor"
                                        initialValue={relacao.fatorMultFornecedor}
                                        label={`1 Medida do Fornecedor equivale a` }
                                    
                                    >
                                        <Input  placeholder="x" suffix={<>{produtoSelecionado.uCom || relacao.unMedida} minhas</>}></Input>
                                    </Form.Item>
                                </>)
                            }
                        })()}
            </Form>
        </Drawer>
    </>)
}

export {FormCadastroProdutoFornecedor};